import { requestJson } from './http';

export function getCallLeads(params = {}) {
  const query = new URLSearchParams(params);
  const qs = query.toString();
  return requestJson(`/api/call/leads${qs ? `?${qs}` : ''}`);
}

export function getCallLeadByPhone(phone) {
  return requestJson(`/api/call/lead?phone=${encodeURIComponent(phone)}`);
}

export function createManualLead(fields) {
  return requestJson('/api/call/lead', {
    method: 'POST',
    body: JSON.stringify({ record: { fields } })
  });
}

export function updateCallLead(recordId, fields) {
  return requestJson(`/api/call/lead/${encodeURIComponent(recordId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ record: { fields } })
  });
}
